export default __webpack_public_path__ + "static/media/layers.b3f5e5e2.png";